import request from "@/utils/request";

// 分页查询
export function queryMonitorTable(data) {
  return request({
    url: "/listener/page",
    method: "post",
    data,
  });
}

//查询详情
export function queryMonitorById(id) {
  return request({
    url: `/listener/${id}`,
    method: "get",
  });
}

// 新增
export function insertMonitor(data) {
  return request({
    url: "/listener/save",
    method: "post",
    data,
  });
}

// 编辑
export function updateMonitor(data) {
  return request({
    url: "/listener/update",
    method: "post",
    data,
  });
}

// 删除
export function deleteMonitorById(id) {
  return request({
    url: `/listener/delete/${id}`,
    method: "delete",
  });
}
